
import RouteMixin from '../mixins/mixin-route'
import AuthMixin  from '../mixins/mixin-auth'

export default {
  mixins: [
    RouteMixin,
    AuthMixin
  ],
  computed: {
    loginPath() {
      return this.pagePath('login')
    },
    loginText() {
      return this.$t('auth.buttons.login')
    },
    registerPath() {
      return this.pagePath('register')
    },
    registerText() {
      return this.$t('auth.buttons.register')
    },
    logoutText() {
      return this.$t('auth.buttons.logout')
    },
    loggedIn() {
      return this.$auth.loggedIn
    }
  },
  methods: {
    logoutUser() {
      this.$auth.logout({
        onSuccess: () => {
          const data = {
            status: 'success',
            notice: this.$t('auth.notifications.loggedOut'),
            messages: [this.$t('auth.notifications.loggedOutMessage')]
          }

          this.notify(data, false)
        },
        onError: data => {
          if (data) {
            this.notify(data, false)
          } else {
            this.notifyError(false)
          }
        }
      })
    }
  },
  render() {
    return this.$scopedSlots.default({
      loggedIn: this.loggedIn,
      loginPath: this.loginPath,
      loginText: this.loginText,
      registerPath: this.registerPath,
      registerText: this.registerText,
      logoutText: this.logoutText,
      logoutUser: this.logoutUser
    })
  }
}
